import Validator from './lib/validator';
import SpecValidator from './lib/spec_validator';

// export singleton
const instance = new SpecValidator();

export {
  Validator,
  SpecValidator,
  instance
};
